// extracted by mini-css-extract-plugin
export var fadeInOut = "_1c-3";
export var icon = "_1c-4";
export var savedIndicator = "_1c-2";
export var savingIndicator = "_1c-0";
export var spin = "_1c-1";